module.exports = __webpack_public_path__ + "img/20220207_zones-02.2c720e9b.png";